module.exports = flarum.core.compat['components/UploadImageButton'];